






























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import UserService from "@/services/user.service";
import TipoEvaluacion from "@/models/evaluacion/tipoEvaluacion.model";
import BaseSelectComponent from "@/components/base/baseSelect/baseSelect.vue";
import { ParesEvaluadoresTypes } from "@/enums/ParesEvaluadoresTypes";
import UrlForm from '@/models/urlForm.model';
@Component({
  components: {
    BaseSelectComponent
  }
})
export default class Add extends GenericAdd<UrlForm> {
  active = false;
  loading: boolean = false;

  constructor() {
    super();
    this.controller = "UrlForm";
    this.model = new UrlForm();
  }

  mounted() {}

  get user() {
    return this.$store.state.user;
  }
}
